import { FC } from 'react';
import { Table as _Table, TableProps as _TableProps, AutoSizer as _AutoSizer, AutoSizerProps } from 'react-virtualized';
import styled from 'styled-components';

export const BaseTable = _Table as unknown as FC<_TableProps>;

export const AutoSizer = _AutoSizer as unknown as FC<AutoSizerProps> & _AutoSizer;

export const TableWrapper = styled.div<{
  $gridheight: number;
  $issubheader: number;
  $isdoubleheaderheight: number;
  $hasscroll: number;
  $clickableRows?: number;
  $hasrownodes?: number;
}>`
  height: ${({ $issubheader, $isdoubleheaderheight, $gridheight }) =>
    $issubheader
      ? $gridheight === 2
        ? `${$gridheight * 123 - 46}px`
        : `${$gridheight * 123 - 126}px`
      : $isdoubleheaderheight
        ? '59px'
        : '30px'};
  ${({ $hasscroll, $issubheader }) => !$hasscroll && !$issubheader && 'width: calc(100% + 9px) !important;'};
  position: relative;

  .ReactVirtualized__Table__headerRow {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ${({ $issubheader }) => $issubheader && 'background-color: var(--table-background-color)'};
    ${({ $issubheader }) => $issubheader && 'background-color: #d4e5ff'};
    border-bottom: 1px solid var(--table-border-bottom-color);
    ${({ $issubheader }) => $issubheader && 'border: 1px solid #e0e0e0'};
    font-size: 16px;
    font-weight: 500;
  }

  .ReactVirtualized__Table__row {
    ${({ $hasscroll, $issubheader }) => !$hasscroll && $issubheader && 'width: calc(100% - 1px) !important;'};
    display: flex;
    color: #4c5e72;
    padding-right: 5px;
    font-size: 15px;
    font-weight: 400;
    border-bottom: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    ${({ $clickableRows }) => $clickableRows && 'cursor: pointer;'}
  }

  ${({ $clickableRows }) =>
    $clickableRows &&
    `
    .ReactVirtualized__Table__rowColumn:nth-of-type(2),
    .ReactVirtualized__Table__rowColumn:nth-of-type(2) * {
      cursor: pointer;
    }
  `}

  .ReactVirtualized__Table__rowColumn:nth-of-type(1) {
    padding-right: 0px !important;
  }

  .ReactVirtualized__Table__rowColumn:has([data-sparkline-cell='true']) {
    overflow: visible !important;

    > div,
    > div > div {
      overflow: visible !important;
    }
  }

  .ReactVirtualized__Table__headerColumn:nth-of-type(2),
  .ReactVirtualized__Table__rowColumn:nth-of-type(2) {
    padding-left: 12px !important;
  }

  .ReactVirtualized__Table__Grid {
    outline: 0 !important;
    box-shadow: none !important;
    height: ${({ $gridheight }) => ($gridheight < 3 ? 'calc(100% - 70px)' : `${$gridheight * 100}px`)};
  }

  .ReactVirtualized__Table__headerColumn {
    width: 100%;
    height: 100%;
    > div {
      padding-bottom: 3px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
    }
  }

  /* Header separators across the full width (body cells draw their own via ChartCell).
     Skip the hidden order column; with a name/index column also skip that label column. */
  .ReactVirtualized__Table__headerRow
    .ReactVirtualized__Table__headerColumn:nth-of-type(n + ${({ $hasrownodes }) => ($hasrownodes ? 3 : 2)}) {
    box-shadow: inset 1px 0 0 #e0e0e0;
  }
`;

export const EmptyHeaderCell = styled('div')<{ $bottom: number }>`
  width: 100%;
  height: 100%;
  background: ${({ $bottom }) => ($bottom ? '#d4e5ff' : 'white')};
`;

export const HeaderCellContainer = styled('div')<{
  $isfirst: number;
  $islast: number;
  $hasscroll: number;
  $issubheader: number;
}>`
  width: 100%;
  height: 100%;
  background: #d4e5ff;
  ${({ $issubheader }) => !$issubheader && 'border-top: 1px solid #e0e0e0;'};
  ${({ $isfirst, $issubheader }) => $isfirst && !$issubheader && 'border-left: 1px solid #e0e0e0;'};
  ${({ $islast, $hasscroll, $issubheader }) =>
    $islast && !$hasscroll && !$issubheader && 'border-right: 1px solid #e0e0e0;'};
`;

export const HeaderCell = styled('div')`
  text-align: center;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HeaderFix = styled('div')<{ $tzoom: number }>`
  width: ${({ $tzoom }) =>
    $tzoom === 90 || $tzoom === 100 || $tzoom === 110
      ? 12
      : $tzoom === 80 || $tzoom === 67 || $tzoom === 125 || $tzoom === 149 || $tzoom === 174 || $tzoom === 199
        ? 12
        : 11}px;
  height: 60px;
  background: #d4e5ff;
  float: right;
  margin-right: ${({ $tzoom }) => ($tzoom === 90 || $tzoom === 100 || $tzoom === 110 ? -1 : 0)}px;
  border-top: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
`;
